import clsx from 'clsx';
import type { ReactNode } from 'react';

import { ScrollArea } from '~components/ui/scroll-area';

type SideBarProps = {
  className?: string;
  children: ReactNode;
};

/**
 * Standard scrollable sidebar. Clients should pass in a width
 *
 * Example usage:
 * ```tsx
 *   <SideBar className="w-(var(--sidebar-width))">
 *     ... contents here
 *   </SideBar>
 * ```
 */
const SideBar = ({ className, children }: SideBarProps) => {
  return (
    <ScrollArea className={clsx(className, 'h-full border-e border-e-border')} type="hover" role="complementary">
      <div className="flex flex-col gap-4 px-4 ps-2 pb-6 sm:px-6">{children}</div>
    </ScrollArea>
  );
};

export { SideBar };
